export const SET_INITIAL_STATE = "SET_INITIAL_STATE";

//--------------------------------RETURN-REASON-LIST------------------------------------------------
export const SET_RETURN_REASON_LIST = "SET_RETURN_REASON_LIST";
export const GET_RETURN_REASON_PENDING = "GET_RETURN_REASON_PENDING";
export const RETURN_REASON_LIST_ERROR = "RETURN_REASON_LIST_ERROR"
export const RETURN_REASON_LIST_ERROR_CLEAR = "RETURN_REASON_LIST_ERROR_CLEAR"

//--------------------------------RETURN-REASON-CREATE----------------------------------------------
export const ADD_RETURN_REASON = "ADD_RETURN_REASON"
export const OPEN_CREATE_RETURN_REASON_MODAL = "OPEN_CREATE_RETURN_REASON_MODAL";
export const CLOSE_CREATE_RETURN_REASON_MODAL = "CLOSE_CREATE_RETURN_REASON_MODAL";
export const CREATE_RETURN_REASON_PENDING = "CREATE_RETURN_REASON_PENDING";
export const CREATE_RETURN_REASON_SUCCESS = "CREATE_RETURN_REASON_SUCCESS";
export const CREATE_RETURN_REASON_ERROR = "CREATE_RETURN_REASON_ERROR";
export const CLEAR_CREATE_RETURN_REASON_ERROR = "CLEAR_CREATE_RETURN_REASON_ERROR";
export const SET_ASSIGNABLE_RETURN_REASON_LIST_ASYNC = "SET_ASSIGNABLE_RETURN_REASON_LIST_ASYNC";

//--------------------------------RETURN-REASON-EDIT------------------------------------------------
export const OPEN_UPDATE_RETURN_REASON_MODAL = "OPEN_UPDATE_RETURN_REASON_MODAL";
export const CLOSE_UPDATE_RETURN_REASON_MODAL = "CLOSE_UPDATE_RETURN_REASON_MODAL";
export const SET_RETURN_REASON_DETAILS = "SET_RETURN_REASON_DETAILS";
export const UPDATE_RETURN_REASON_PENDING = "UPDATE_RETURN_REASON_PENDING";
export const UPDATE_RETURN_REASON_SUCCESS = "UPDATE_RETURN_REASON_SUCCESS";
export const UPDATE_RETURN_REASON_ERROR = "UPDATE_RETURN_REASON_ERROR";
export const CLEAR_UPDATE_RETURN_REASON_ERROR = "CLEAR_UPDATE_RETURN_REASON_ERROR"
